'use client';

import { Modale } from '@/app/components/modale/Modale';
import { useModale } from '@/app/hooks/useModale';
import { IHomeWelcome } from '@/types/home/homeWelcome';
import Image from 'next/image';
import Link from 'next/link';

export const HomeWelcome: React.FC<IHomeWelcome> = ({
  text,
  textButton1,
  textButton2,
}): React.JSX.Element => {
  const { isModaleVisible, openModale, closeModale } = useModale();

  return (
    <>
      <div className="flex items-center justify-center lg:min-h-[21rem] md:min-h-[15rem] sm:min-h-[13rem] xs:min-h-[13rem]">
      <Image
          src="/images/background-welcome.png"
          alt="Arrière plan de bienvenue"
          title="Arrière plan de bienvenue"
          width={500}
          height={500}
          priority
          className="absolute w-full object-cover object-center"
        />

        <div className="absolute inset-0 bg-black bg-opacity-60"></div>

        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white">
          <h2
            id="home-welcome-title"
            className="xl:text-4xl lg:text-4xl sm:text-3xl xs:text-2xl font-primaryBold"
          >
            Bienvenue sur <span className="text-red-600">The Club</span>
          </h2>
          <p className="lg:text-lg sm:text-base xs:text-sm md:text-base md:mt-6 xs:mt-4 xs:max-w-lg md:max-w-2xl lg:max-w-3xl xl:max-w-5xl font-primary">
            {text}
          </p>
          <div className="flex gap-4 lg:text-lg md:text-base sm:text-md xs:text-sm md:mt-6 xs:mt-4 font-primaryBold">
            <Link
              href="/spots"
              title="Découvrir les spots"
              className="bg-red-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2"
            >
              {textButton1}
            </Link>
            <Link
              href="#"
              title="Rejoindre la communauté"
              onClick={(e) => {
                e.preventDefault();
                openModale();
              }}
              className="bg-white text-black px-4 py-2 rounded-lg font-semibold shadow-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
            >
              {textButton2}
            </Link>
          </div>
        </div>
      </div>

      {isModaleVisible && <Modale closeModale={closeModale}></Modale>}
    </>
  );
};
